import axios from "axios";
import apiEndpoints from "../config/apiEndpoints";
import { fetchData } from "../utils/utils";



export const getCombinationListReservation = async (key) => {
  const endpoint = apiEndpoints.GET_COMBINATION_LIST_RESERVATION(key);
  const result = await fetchData({ endpoint, method: "GET"});
  if (!result.success) {
    console.error(result.message);
  } 
  else {
    console.log("Combination List:", result);
  }
 
  return result;
};